import React from "react"
import { Container, Row, Col } from "react-bootstrap"

import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Logofluo from "@images/fluo-foundation.png"

export default function Foundation() {
  return (
    <section className="foundation-section section-padding">
      {/* <div className="video-background">
        <video autoPlay loop muted id="myvideo">
          <source src="https://res.cloudinary.com/dbzxlf4i4/video/upload/v1615429279/Fantastic_Wave_Loop_shutterstock_4801631_1_dniczz.mp4" />
        </video>
      </div> */}
      <Container>
        <Row>
          <Col lg="8" className="">
            <div className="foundation-content text-left text-white">
              <div className="d-flex align-items-center mb-5 flex-wrap">
                <img
                  className="img-fluid mr-2 mb-4"
                  src={Logofluo}
                  alt="Foundation Logo"
                />
                <h2 className="">
                  <span className="section-title d-block">FLUO Foundation</span>
                  <span className="font-italic">
                    Inspiring Our Youth to Feel Alive
                  </span>
                </h2>
              </div>
              <p className="mb-6">
                As a community-galvanized 501(c)(3) nonprofit, the FLUO
                Foundation is devoted to fostering a greater understanding of
                our youth’s mental health needs through education and
                inspiration. By addressing the primary source of mental health
                problems, we seek to help children, teens and young adults
                navigate, protect, and sustain healthy minds.
              </p>
              <Link to="/why-fluo" className="cta text-uppercase">
                why fluo foundation?
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
